import { GtmEvent } from '@emico-utils/datalayer-templates'
import React from 'react'

import useCartItems from './useCartItems'
import { usePushEcommerceEvent } from './usePushEvent'

const useViewCart = () => {
    const { items } = useCartItems()
    const [eventTriggered, setEventTriggered] = React.useState<boolean>(false)

    const push = usePushEcommerceEvent([], false)

    React.useEffect(() => {
        if (!items || eventTriggered) {
            return
        }
        const event: GtmEvent = {
            event: 'view_cart',
            ecommerce: {
                items,
            },
        }

        setEventTriggered(true)

        push?.([{ ecommerce: null }, event])
    }, [items, eventTriggered, setEventTriggered, push])
}

export default useViewCart
